import './residences.scss'
import { BackLink, BaseButton, ResidenceCardGrid, ResidenceCardSkeletonGrid } from 'components'
import { usePageTitle, useSearch } from 'hooks'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IonSpinner } from '@ionic/react'
import { ISearchParams } from 'interfaces'
import { stringService } from 'services'
import BasePage from 'pages/base-page/base-page.page'
import { useLocation } from 'react-router'

const LIST_BLOCK_SIZE = 8

const DEFAULT_SEARCH_PARAMS: ISearchParams = {
  limit: LIST_BLOCK_SIZE,
  offset: 0,
}

const Residences: React.FC = () => {
  const [resultsLoaded, setResultsLoaded] = useState(false)
  const [searchParams, setSearchParams] = useState<ISearchParams>(DEFAULT_SEARCH_PARAMS)
  const [loadMore, setLoadMore] = useState<boolean>(false)
  const { search } = useLocation()
  const searchResults = useSearch(searchParams)

  const { t } = useTranslation()
  const titlePage = stringService.capitalizeFirstLetter(t('our_residences'))
  usePageTitle(titlePage!)

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const cParam = urlSearchParams.get('c')

    if (cParam) {
      setSearchParams((sp) => {
        return { ...sp, cityId: cParam }
      })
    } else {
      setSearchParams(DEFAULT_SEARCH_PARAMS)
    }
  }, [search])

  useEffect(() => {
    if (searchResults) {
      setResultsLoaded(true)
      setLoadMore(false)
    }
  }, [searchResults])

  const onLoadMoreClick = () => {
    setLoadMore(true)
    setSearchParams((sp) => {
      return {
        ...sp,
        limit: LIST_BLOCK_SIZE,
        offset: (sp?.offset || 0) + LIST_BLOCK_SIZE,
      }
    })
  }

  return (
    <BasePage pageClass="edisu-page-residences">
      {!!searchParams?.dateFrom ? null : <BackLink link={'/'}></BackLink>}
      <h2>{t('our_residences')}</h2>

      <div className="result-cnt mobile-spaced ">
        <ResidenceCardGrid
          residences={searchResults?.data?.map((residence) => {
            return { residence }
          })}
          searchParams={searchParams}
          loadingComponent={!resultsLoaded && <ResidenceCardSkeletonGrid count={4} />}
        />
        {resultsLoaded && searchResults?.hasMore && (
          <div className="load-more-cnt">
            {loadMore ? (
              <IonSpinner name="crescent" color="primary" />
            ) : (
              <BaseButton onClickFunction={() => onLoadMoreClick()} label={t('load_more')} />
            )}
          </div>
        )}
      </div>
    </BasePage>
  )
}

export default Residences
